import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import ListGender from 'shell/components/shared/gender';
import PmiTextField from 'shell/components/shared/text-field';
import { PersonFormVM } from '../form';

interface GeneralityComponentProps {
  onChange: (key: keyof PersonFormVM, value: PersonFormVM[keyof PersonFormVM]) => void;
  values?: PersonFormVM;
  onSearch: () => void;
  disabled?: boolean;
  onChangeFields: (values: PersonFormVM) => void;
}

const GeneralityComponent = ({
  onChange,
  values,
  onSearch,
  disabled,
  onChangeFields,
}: GeneralityComponentProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={1} xs={12}>
        <Grid item xs={12} md={6}>
          <PmiTextField
            label="Codice fiscale"
            aria-label="Codice fiscale"
            id="fiscal-code"
            fullWidth
            value={values?.fiscalCode?.toUpperCase() || ''}
            onChange={(event) => onChange('fiscalCode', event.target.value)}
            disabled={disabled}
            inputProps={{ maxLength: '16' }}
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} xs={12} alignItems="center">
        <Grid item xs={12} md={9}>
          <PmiTextField
            label="Cognome"
            aria-label="Cognome"
            id="surname"
            fullWidth
            value={values?.surname || ''}
            onChange={(event) => onChange('surname', event.target.value)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="withoutSurname"
                checked={values?.withoutSurname}
                onChange={() =>
                  onChangeFields({
                    surname: !values?.withoutSurname ? '' : values?.surname || '',
                    withoutSurname: !values?.withoutSurname,
                  } as PersonFormVM)
                }
                disabled={disabled}
                inputProps={{ 'aria-label': 'Persona senza cognome' }}
              />
            }
            label="Persona senza cognome"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} xs={12} alignItems="center">
        <Grid item xs={12} md={9}>
          <PmiTextField
            label="Nome"
            aria-label="Nome"
            id="name"
            fullWidth
            value={values?.name || ''}
            onChange={(event) => onChange('name', event.target.value)}
            disabled={disabled}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="withoutName"
                checked={values?.withoutName}
                onChange={() =>
                  onChangeFields({
                    name: !values?.withoutName ? '' : values?.name || '',
                    withoutName: !values?.withoutName,
                  } as PersonFormVM)
                }
                disabled={disabled}
                inputProps={{ 'aria-label': 'Persona senza nome' }}
              />
            }
            label="Persona senza nome"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} alignItems="center" xs={12}>
        <Grid item xs={12} md={6}>
          <ListGender
            value={values?.gender || ''}
            onChange={(event) => onChange('gender', event.target.value)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiButton
            variant="contained"
            color="secondary"
            fullWidth
            disabled={!values?.fiscalCode && !(values?.name && values?.surname)}
            onClick={onSearch}
          >
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

GeneralityComponent.displayName = 'FormFilter component';

const FormFilter = memo(GeneralityComponent);

export default FormFilter;
